import React, { useEffect, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import { useNavigate } from 'react-router-dom';

function Exams() {

  const navigate = useNavigate();

  const [showOptions,setShowOptions] = useState(0);
  const [refresh,setRefresh] = useState(false);
  const [refresh2,setRefresh2] = useState(false);

  const [shownExams,setShownExams] = useState([]);
  const [generalExams,setGeneralExams] = useState([]);
  const [courseExams,setCourseExams] = useState([]);
  const [courseExercise,setCourseExercise] = useState([]);
  const [allExams,setAllExams] = useState([]);

  const getAllExams = ()=>{
    senddata(`teacher/exam/get_allexams`,{}, "GET").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت');
      } else {
        setAllExams(res.data);
        const filteredCourses1 = res.data.filter((exercise)=> exercise.title=="exercise"||exercise.title=="exerciseinvideo" );
        const filteredCourses2 = res.data.filter((exercise)=> exercise.title=="single_exam" );
        const filteredCourses3 = res.data.filter((exercise)=> (exercise.title!="single_exam"&&exercise.title!="exercise")&&exercise.title!="exerciseinvideo" );
        setCourseExercise(filteredCourses1);
        setGeneralExams(filteredCourses2);
        setCourseExams(filteredCourses3);
        setRefresh2(!refresh2)
      }
      });
  }

  useEffect(()=>{
    getAllExams();
  },[refresh])

  useEffect(()=>{
    if(showOptions==1){
      setShownExams(courseExercise);
    }else if (showOptions==2){
      setShownExams(courseExams);
    }else if (showOptions==3){
      setShownExams(generalExams);
    }
  },[showOptions,refresh2]);

  const handledelete = (exam)=>{
    const id =exam._id
    if(exam.title=="exerciseinvideo"){
      alert("لا يمكن حذف الامتحان");
      return;
    }
    const userResponse = prompt(`اكتب ok لتأكيد حذف الامتحان `);
    if(userResponse?.trim() =="ok" ){
    senddata(`teacher/exam/delete_exam/${id}`,{}, "Delete").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
        alert('تم مسح الامتحان بنجاح  ');
        setRefresh(!refresh);
      }
      });
    }else{
      alert("لم يتم حذف الامتحان ")
    }
  }


  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      <div className='w-full flex flex-row justify-around items-center mt-6'>
        <p onClick={()=>{setShowOptions(1)}} className={`px-4 py-2 mb-4 w-fit rounded-full cursor-pointer ${showOptions==1?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> تدريبات الكورس </p> 
        <p onClick={()=>{setShowOptions(2)}} className={`px-4 py-2 mb-4 w-fit rounded-full cursor-pointer ${showOptions==2?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>امتحانات الكورس </p> 
        <p onClick={()=>{setShowOptions(3)}} className={`px-4 py-2 mb-4 w-fit rounded-full cursor-pointer ${showOptions==3?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>امتحانات عامة </p> 
      </div>

          {shownExams?.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 min-h-screen '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>اسم الامتحان</div>
                  <div className='text-base w-[150px] text-center'>العنوان</div>
                  <div className='text-base w-[100px] text-center'> السنة</div>
                  <div className='text-base w-[200px] text-center'> البداية</div>
                  <div className='text-base w-[200px] text-center'>  النهاية</div>
                  <div className='text-base w-[150px] text-center'>اتاحة النتيجة</div>
                  <div className='text-base w-[100px] text-center'>تفاصيل</div>
                  <div className='text-base w-[100px] text-center'>مسح</div>
                </div>
              {shownExams?.map((exam) => {
                const dateStart = new Date(exam.start);
                const dateEnd = new Date(exam.end);
                const options = {
                  year: 'numeric',
                  month: 'long', 
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: true 
                };
                const readableDateStart = dateStart.toLocaleString('en-US', options);
                const readableDateEnd = dateEnd.toLocaleString('en-US', options);

                return(
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit items-center ' key={exam._id}> 
                  <div className='text-base w-[150px] text-center'> {exam.title=="exercise"?"تدريب":exam.title=="exerciseinvideo"?"تدريب فيديو":exam.title=="single_exam"?"امتحان عام":exam.title }</div>
                  <div className='text-base w-[150px] text-center'>{exam.describtion}</div>
                  <div className='text-base w-[100px] text-center'>{exam.level}</div>
                  <div className='text-base w-[200px] text-center px-8'>{exam.start=="unlimited"?"مفتوح":readableDateStart}</div>
                  <div className='text-base w-[200px] text-center px-8'>{exam.end=="unlimited"?"مفتوح":readableDateEnd}</div>
                  <div className='text-base w-[150px] text-center'>{"" +exam.results_available}</div>
                  <div onClick={()=>{navigate("/exam",{ state: exam });}} className='text-base w-[100px] text-center flex justify-center'><p className='  w-fit rounded-full cursor-pointer'>🕵️‍♀️</p> </div>
                  <div onClick={()=>{handledelete(exam)}} className='text-base w-[100px] text-center flex justify-center'><p className='  w-fit rounded-full cursor-pointer'>🗑️</p> </div>
                </div>
              )})}
              </div>
          )}
      
    </div>
  )
}

export default Exams
